<template>
  <div>
    <v-card class="mx-auto my-4" max-width="700">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <h1 class="text-h5 font-weight-bold mb-1">Support</h1>
            <p class="mb-4">
              Answers to common questions. Can't find what you're looking for?
              <router-link to="/contact">Contact us</router-link>
              and we'll help you out.
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-expansion-panels>
              <v-expansion-panel v-for="(faq, i) in faqs" :key="i">
                <v-expansion-panel-header>
                  {{ faq.question }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p class="mb-0" v-html="faq.answer"></p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="mt-4">
            <p class="mb-0">
              Still stuck? <router-link to="/contact">Get in touch</router-link>
              and describe what's going on.
            </p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      faqs: [
        {
          question: "What is FaangIT.com?",
          answer:
            "FaangIT.com helps you get your resume in shape for top tech companies. Our AI review tools check your resume the way employers' automated filters do, and give you tailored feedback. Review from experienced human reviewers is coming soon.",
        },
        {
          question: "What does AI review check for?",
          answer:
            'AI review runs automated checks (formatting, ATS compatibility, keyword coverage) and gives instant, tailored feedback. You can start with a <a href="/evaluate-ai">free AI review</a> any time.',
        },
        {
          question: "What review tiers are available?",
          answer:
            "We offer Basic, Full and Targeted AI review tiers. Basic is a quick, free pass to check the fundamentals; Full and Targeted go deeper, covering things like career progression and tailored feedback for a specific role.",
        },
        {
          question: "Is FaangIT.com free to use?",
          answer:
            'Basic AI review is free. Full and Targeted AI review are paid. See <a href="/gopro">Go Pro</a> for details on subscription plans.',
        },
        // {
        //   question: "How do I become a reviewer?",
        //   answer:
        //     'Human review is coming soon, and we are already lining up experienced reviewers for launch. You can apply from the <a href="/reviewer-enrollment/info">become a reviewer</a> page.',
        // },
        {
          question: "I forgot my password - what do I do?",
          answer:
            'Use the <a href="/password-reset">password reset</a> page to get a reset link sent to your email.',
        },
        {
          question: "How is my resume/data used?",
          answer:
            'See our <a href="/legal#privacy-policy">Privacy Policy</a> for details on what we collect and how it\'s used. We never sell your personal data.',
        },
        {
          question: "I found a bug - where do I report it?",
          answer:
            'Use the "Report a problem" link in the footer from wherever you ran into the issue - it automatically includes the page you were on, which helps us track it down faster.',
        },
      ],
    };
  },
  mounted() {
    this.$utils.visit(this);
  },
};
</script>

<style></style>
